module.exports = __webpack_public_path__ + "static/media/map_us_states.9e05210b.png";